module.exports = __webpack_public_path__ + "media/images/menu/cassiopeia-2c1d5caceb9872098a87b116d40aa8d0.jpg";